<template>
  <RevButtonBase
    class="bg-surface-default-low rounded-lg mx-auto flex w-full max-w-[500px] flex-col items-start gap-4 border p-12 hover:bg-surface-brand-hi hover:shadow-short"
    :class="[
      $style.buttonContainer,
      {
        'border-action-default-low': !modelValue,
        'bg-surface-brand-hi border-action-default-hi': modelValue,
        'bg-action-default-low-disabled': disabled,
      },
    ]"
    @click="handleClick"
  >
    <div
      class="bg-surface-brand-low rounded-md mb-8 flex w-full items-end justify-end overflow-hidden"
    >
      <RevIllustration
        :alt="label"
        :class="$style.image"
        :height="624"
        :src="imagesSrc.src"
        :width="994"
      />
      <RevIllustration
        :alt="label"
        :class="$style.imageMobile"
        :height="532"
        :src="imagesSrc.srcMobile"
        :width="608"
      />
    </div>
    <p class="body-1-bold">{{ label }}</p>
    <p class="body-2 text-left">{{ description }}</p>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    label: string
    description: string
    imagesSrc: { srcMobile: string; src: string }
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const handleClick = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style module>
.buttonContainer {
  container-type: inline-size;
  container-name: button-container;
}
.image-mobile {
  display: block;
}
.image {
  display: none;
}
@container button-container (width > 450px) {
  .image {
    display: block;
  }

  .imageMobile {
    display: none;
  }
}
</style>
